import baseLogger, { CONTEXTS } from 'widget/logger';
import createTaggedUrl from 'api/createTaggedUrl';
import HttpError from 'widget/Errors/HttpError';
import Logger from 'modules/Logger/Logger';
import { Episode } from 'state/Podcast/types';
import { TransportInterface } from 'widget/utils/transport/types';
/*
 * Fetch podcast data given a podcast id
 */
export async function fetchPodcastEpisodes({
  ampUrl = '',
  logger = baseLogger,
  podcastId,
  sortAsc,
  transport,
}: {
  ampUrl?: string;
  logger?: Logger;
  podcastId: number | null;
  sortAsc: boolean;
  transport: TransportInterface;
}): Promise<Array<Episode>> {
  if (!podcastId) {
    const errObj = new HttpError(
      400,
      'Failed to fetch podcast info, podcast id missing.',
    );
    logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
    throw errObj;
  }
  const sortBy = sortAsc ? 'startDate-asc' : 'startDate-desc';

  const [url, requestName] = createTaggedUrl`${{
    ampUrl,
  }}/api/v3/podcast/podcasts/${{
    podcastId: String(podcastId),
  }}/episodes?sortBy=${{ sortBy }}`;

  const { data } = await transport.get(url, { params: { requestName } });
  return data.data;
}
